import htmx from 'htmx.org';
import { Params } from "../Shared/scriptts/search-params";
import { getUserObject, isAuthenticated } from "../Shared/scriptts/session/sessionmain";
import { bindToggles } from "../Shared/scriptts/rootcomponents/toggle";
import { setParams, signinClick } from './search-main';

let firstToggleClick = true;

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLInputElement>('#SearchName, #SearchName_m').forEach(elem => elem.addEventListener('keyup', searchNameKeyup));
    document.querySelectorAll<HTMLInputElement>('#EmailFrequency, #EmailFrequency_m').forEach(elem => elem.addEventListener('change', searchFrequencyChanged));
    document.querySelectorAll<HTMLInputElement>('#save-search-submit, #save-search-submit_m').forEach(elem => elem.addEventListener('click', saveSearchClick));
    document.querySelectorAll<HTMLButtonElement>('#save-search-signin, #save-search-signin_m').forEach(elem => elem.addEventListener('click', signinClick));
    document.querySelectorAll<HTMLButtonElement>('[data-target=save-search_1], #toggle-savedsearch_m, #save-search-cancel_m, #save-search-close_m').forEach(elem => elem.addEventListener('click', saveSearchToggleClick));
});

export function displaySaveSearchForm(visible: boolean) {
    if (visible === true) {
        document.querySelector<HTMLElement>('#save-search-container')?.classList.remove('hidden');
        document.querySelector<HTMLButtonElement>('#toggle-savedsearch_m')?.classList.remove('hidden');
        if (isAuthenticated() === true) {
            document.querySelector<HTMLElement>('#save-search-auth')?.classList.remove('hidden');
            document.querySelector<HTMLElement>('#save-search-noauth')?.classList.add('hidden');
        }
        else {
            document.querySelector<HTMLElement>('#save-search-auth')?.classList.add('hidden');
            document.querySelector<HTMLElement>('#save-search-noauth')?.classList.remove('hidden');
        }
    }
    else {
        document.querySelector<HTMLElement>('#save-search-container')?.classList.add('hidden');
        document.querySelector<HTMLButtonElement>('#toggle-savedsearch_m')?.classList.add('hidden');
    }
}

export function setSavedSearchParams(savedSearchParams: Params) {
    delete savedSearchParams.SavedSearchID;
    setParams(savedSearchParams);
}

export function updateSavedSearchFields(savedSearchParams: Params) {
    const savedSearchTitle = document.getElementById('title-save-search_1');
    const mobileSavedSearchTitle = document.getElementById('title-save-search_m');
    const savedSearchIds = document.querySelectorAll('input[name="CandidateSavedSearchID"]');
    const searchNames = document.querySelectorAll('input[name="SearchName"]');
    const emailFrequencies = document.querySelectorAll('select[name="EmailFrequency"]');
    if (!savedSearchIds || !emailFrequencies || !searchNames || !mobileSavedSearchTitle || !savedSearchTitle) {
        return;
    }
    savedSearchTitle.textContent = "Saved search: ";
    const spanDesktop = document.createElement("span");
    spanDesktop.className = "font-normal text-gray-darkest";
    spanDesktop.textContent = savedSearchParams.SavedSearchName ?? "";
    savedSearchTitle.appendChild(spanDesktop);
    mobileSavedSearchTitle.textContent = "Saved search: ";
    const spanMobile = document.createElement("span");
    spanMobile.className = "font-normal";
    spanMobile.textContent = savedSearchParams.SavedSearchName ?? "";
    mobileSavedSearchTitle.appendChild(spanMobile);
    savedSearchIds.forEach(field => (<HTMLInputElement>field).value = savedSearchParams.SavedSearchID?.toString() ?? "");
    searchNames.forEach(field => (<HTMLInputElement>field).value = savedSearchParams.SavedSearchName ?? "");
    emailFrequencies.forEach(field => (field as HTMLSelectElement).value = savedSearchParams.EmailFrequency ?? "");
}

function searchNameKeyup(evt: Event) {
    const elem = <HTMLInputElement>(evt.target);
    const value = elem.value;
    document.querySelectorAll<HTMLInputElement>('#SearchName, #SearchName_m').forEach(input => input.value = value);
}

function searchFrequencyChanged(evt: Event) {
    const elem = <HTMLInputElement>(evt.target);
    const value = elem.value;
    document.querySelectorAll<HTMLInputElement>('#EmailFrequency, #EmailFrequency_m').forEach(input => input.value = value);
}

function saveSearchToggleClick(evt: Event) {
    if (!firstToggleClick) {
        return;
    }
    firstToggleClick = false;   
    const elem = <HTMLButtonElement>(evt.target);
    if (elem.id === 'toggle-savedsearch_m' || elem.id === 'save-search-cancel_m' || elem.id === 'save-search-close_m') {
        document.querySelector<HTMLButtonElement>('[data-target=save-search_1]')?.dispatchEvent(new Event('click'));
    }

    const userObject = getUserObject();
    if (userObject.IsAuthenticated) {
        document.querySelector<HTMLElement>('#save-search-noauth_m')?.classList.add('hidden');
        document.querySelector<HTMLElement>('#save-search-auth_m')?.classList.remove('hidden');
    } else {
        document.querySelector<HTMLElement>('#save-search-noauth_m')?.classList.remove('hidden');
        document.querySelector<HTMLElement>('#save-search-auth_m')?.classList.add('hidden');
    }
    firstToggleClick = true;
}

function saveSearchClick(evt: Event) {
    htmx.on('htmx:afterSwap', () => {
        bindToggles();
    });
}
